import "../../../styles/panel/user/OwnerStep.css";

export default function OwnerStep({ owner, setOwner }) {
  return (
    <>
      <h3 className="request-step-title">اطلاعات مالک</h3>
      <p className="request-step-sub">
        این شماره برای صدور قرارداد و ارتباط با شما استفاده می‌شود
      </p>

      <div className="owner-mobile-card">
        <span className="owner-mobile-icon" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinejoin="round"
            />
            <path
              d="M11 18h2"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
            />
          </svg>
        </span>

        <div className="owner-mobile-body">
          <label htmlFor="owner-mobile" className="owner-mobile-label">
            شماره موبایل
          </label>
          <input
            id="owner-mobile"
            type="text"
            className="owner-mobile-input"
            value={owner.mobile}
            onChange={(e) => setOwner({ ...owner, mobile: e.target.value })}
            placeholder="۰۹xxxxxxxxx"
            inputMode="numeric"
            readOnly
          />
        </div>

        {/* <span className="owner-mobile-badge">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m5 13 4 4L19 7"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          تأییدشده
        </span> */}
      </div>
    </>
  );
}

export function isOwnerStepValid(owner) {
  // فقط شماره موبایل الزامی است
  return !!owner.mobile.trim();
}
